import { featureCollection } from '@turf/turf';
import { Feature, LineString } from 'geojson';
import { SHARED_GENERATE_INPUTS } from './reversePointsAndRows';
import lineOffset from '../betterLineOffset';
import { feetPerMile } from '../../constants/units';
import generateRowPoints from './generateRowPoints';
import {
  DataMaps,
  PointsAndRows,
  PointsAndRowsProps,
} from '../../types/pointsAndRows';
import {
  DEFAULT_BETWEEN_ROW_SPACING,
  DEFAULT_IN_ROW_SPACING,
} from '../../constants/fields';
import { unitsMiles } from '../units';

interface GenerateLinePointsAndRowsProps extends PointsAndRowsProps {
  fieldFeature: Feature<LineString>;
  inputRowCount?: number;
}

export const GENERATE_LINE_INPUTS = [
  'fieldFeature',
  'inRowSpacing',
  'betweenRowSpacing',
  'inputRowCount',
  'rowOverrides',
  'crop',
  'primaryInRowPattern',
  ...SHARED_GENERATE_INPUTS,
];

/**
 * Generates rows at specified betweenRow spacing, and
 * generates points within those rows at a specified inRowSpacing (in feet).
 */
const generateLinePointsAndRows = (
  // Update GENERATE_LINE_INPUTS above if these params change
  {
    fieldFeature,
    inRowSpacing = DEFAULT_IN_ROW_SPACING,
    betweenRowSpacing = DEFAULT_BETWEEN_ROW_SPACING,
    inputRowCount = 1,
    rowOverrides,
    crop,
    primaryInRowPattern,
  }: GenerateLinePointsAndRowsProps,
  dataMaps: DataMaps,
) => {
  if (!fieldFeature) return {} as PointsAndRows;
  const rows = featureCollection(
    [...Array(inputRowCount).keys()].map((i) =>
      lineOffset(
        fieldFeature,
        (i * betweenRowSpacing) / feetPerMile,
        unitsMiles,
      ),
    ),
  );
  return generateRowPoints(
    { rows, inRowSpacing, crop, primaryInRowPattern, rowOverrides },
    dataMaps,
  );
};

export default generateLinePointsAndRows;
